"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntitySearchItem = /** @class */ (function () {
    /**
     * Basic constructor that initializes the state.
     * @param {number} id
     * @param {string} displayName
     * @param {any} entity
     */
    function EntitySearchItem(id, displayName, entity) {
        this.id = id;
        this.displayName = displayName;
        this.entity = entity;
    }
    return EntitySearchItem;
}());
exports.EntitySearchItem = EntitySearchItem;
//# sourceMappingURL=entity-search-item.js.map